import {_axios} from "@/plugins/axios";

//Não está a ser utilizado. Comentei para não enganar
// export function authHeader() {
//     // return authorization header with jwt token
//     let user = JSON.parse(localStorage.getItem('user'));
//
//     if (user && user.token) {
//         return {'Authorization': 'JWT ' + user.token};
//     } else {
//         return {};
//     }
// }

export function setAxiosDefaultHeaders() {

    let user = JSON.parse(localStorage.getItem('user'));

    // @modified ana.castro 2019.09.24 SCLAPP-20 Now the Token it's stored on the ACCESS attribute
    if (user && user.access) {
        //Vue.axios.defaults.headers.common['Authorization'] = 'JWT ' + user.access;
        // Inspirado aqui: https://github.com/axios/axios/issues/209 apesar de não perceber a diferença
        // @modified ana.castro 2019.09.24 SCLAPP-20 Now the Token it's stored on the ACCESS attribute
        //Vue.axios.defaults.headers.authorization = 'JWT ' + user.access;
        _axios.defaults.headers['Authorization'] = 'JWT ' + user.access;
    } else {
        delete _axios.defaults.headers['Authorization'];
        delete _axios.defaults.headers['Authorization'];
    }
}
